(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('ul'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-page-truly-grass-fed"]) return;
  try {
    
const SCROLL_ANIMATION_TRIGGER_CLASSNAME = 'scroll-trigger';
const SCROLL_ANIMATION_ACTIVE_CLASSNAME = 'scroll-trigger--active';

function onIntersection(elements, observer) {
  elements.forEach((element, index) => {
    if (element.isIntersecting) {
      const elementTarget = element.target;
      elementTarget.classList.add(SCROLL_ANIMATION_ACTIVE_CLASSNAME);
      if (elementTarget.hasAttribute('data-cascade'))
        elementTarget.setAttribute('style', `--animation-order: ${index};`);
      observer.unobserve(elementTarget);
    }
  });
}

function initializeScrollAnimationTrigger(rootEl = document) {
  const animationTriggerElements = Array.from(rootEl.getElementsByClassName(SCROLL_ANIMATION_TRIGGER_CLASSNAME));
  if (animationTriggerElements.length === 0) return;

  const observer = new IntersectionObserver(onIntersection, {
    threshold: 0.1,
  });
  animationTriggerElements.forEach((element) => observer.observe(element));
}

window.addEventListener('DOMContentLoaded', () => initializeScrollAnimationTrigger());

document.addEventListener('shopify:section:load', (event) => initializeScrollAnimationTrigger(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
          element.classList.remove('active');
        }
      )
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      const container = this.querySelector('[role="document"]');
      container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }
  }

  customElements.define('product-modal', ProductModal);
  

  class ProductGallery extends HTMLElement {
    constructor() {
      super();
      this.init()

      // Add resize observer to update container height
      /* const resizeObserver = new ResizeObserver(entries => this.update());
      resizeObserver.observe(this); */

      // Bind event listeners
      this.navItems.forEach(item => item.addEventListener('click', this.onNavItemClick.bind(this)))
      this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
      this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
    }

    init() {
      // Set up our DOM element variables
      this.imagesContainer = this.querySelector('.product-gallery__images');
      this.navItems = this.querySelectorAll('.product-gallery__nav-item');
      this.images = this.querySelectorAll('.product-gallery__image');
      this.prevButton = this.querySelector('button[name="previous"]');
      this.nextButton = this.querySelector('button[name="next"]');
      // If there is no active images set the first image to active
      if (this.findCurrentIndex() === -1) {
        this.setCurrentImage(this.images[0])
      }
    }

    onNavItemClick(event) {
      const mediaId = event.target.closest('li').dataset.mediaId;
      this.navItems.forEach(item => item.classList.remove('product-gallery__nav-item--active'));
      // this.images.forEach(item => item.classList.remove('product-gallery__image--active'));
      event.target.closest('li').classList.add('product-gallery__nav-item--active');
      this.setCurrentImage(Array.from(this.images).find(item => item.dataset.mediaId === mediaId));
    }

    update() {
      /* this.style.height = `${this.imagesContainer.offsetHeight}px` */
      this.prevButton.removeAttribute('disabled')
      this.nextButton.removeAttribute('disabled')
      if (this.findCurrentIndex() === 0) this.prevButton.setAttribute('disabled', true)
      if (this.findCurrentIndex() === this.images.length - 1) this.nextButton.setAttribute('disabled', true)
    }

    setCurrentImage(elem) {
      this.images.forEach(item => item.classList.remove('product-gallery__image--active'))
      elem.classList.add('product-gallery__image--active')
      this.update()
    }

    findCurrentIndex() {
      return Array.from(this.images).findIndex(item => item.classList.contains('product-gallery__image--active'))
    }

    onButtonClick(event) {
      event.preventDefault();
      let index = this.findCurrentIndex()
      if (event.currentTarget.name === 'next') {
        index++
      } else {
        index--
      }
      this.setCurrentImage(this.images[index])
    }
  }

  customElements.define('product-gallery', ProductGallery);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-gainz-gauge"] && !window.DesignMode) return;
  try {
    
  const progressBarsToObserve = document.querySelectorAll('.gainz-gauge__progress-bar');

  function handleIntersection(entries) {
    entries.map((entry) => {
      if (entry.isIntersecting) {
        entry.target.classList.add('js-intersection-visible')
        observer.unobserve(entry.target);
      }
    });
  }

  const observer = new IntersectionObserver(handleIntersection);

  progressBarsToObserve.forEach(elem => observer.observe(elem));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-ingredient-circles"] && !window.DesignMode) return;
  try {
    
  const circlesToObserve = document.querySelectorAll('.ingredient-circles__grid-item--image');
  function handleIntersection(entries) {
    entries.map((entry) => {
      if (entry.isIntersecting) {
        entry.target.classList.add('js-intersection-visible')
        observer.unobserve(entry.target);
      }
    });
  }

  const observer = new IntersectionObserver(handleIntersection);

  circlesToObserve.forEach(elem => observer.observe(elem));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }
          })
          .catch(e => {
            console.log('product-recommendations.liquid error:');
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-three-icons"] && !window.DesignMode) return;
  try {
    
  const iconsToObserve = document.querySelectorAll('.three-icons .grid__item > .icon');
  function handleIntersection(entries) {
    entries.map((entry) => {
      if (entry.isIntersecting) {
        entry.target.classList.add('js-intersection-visible')
        observer.unobserve(entry.target);
      }
    });
  }

  const observer = new IntersectionObserver(handleIntersection);

  iconsToObserve.forEach(elem => observer.observe(elem));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-why-efm"] && !window.DesignMode) return;
  try {
    
  const shakerIconToObserve = document.querySelectorAll('.product-why-efm-section svg');

  function handleIntersection(entries) {
    entries.map((entry) => {
      if (entry.isIntersecting) {
        entry.target.classList.add('js-intersection-visible')
        observer.unobserve(entry.target);
      }
    });
  }

  const observer = new IntersectionObserver(handleIntersection);

  shakerIconToObserve.forEach(icon => observer.observe(icon));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-you-may-also-like"] && !window.DesignMode) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }
          })
          .catch(e => {
            console.log('product-recommendations.liquid error:');
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
